import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment';
import PageTracker from '../../../common/PageTrackerHelper'
import { applySmartInputStyles, clearSmartInputStyles, createClearInputWatcher } from "../../../common/inputStyleHelper";

export default {
  name: 'ReverseShipmentDetails',
  components: {
    VueElementLoading
  },
  mixins:[PageTracker],
  data: function() {
    return {
      shippingId:'',
      showProductDetailsTable:false,
      showShipmentLogTable:false,
      isProductDetailsTableLoading:false,
      isShipmentLogTableLoading:false,
      showShipmentDetails:false,
      isTableLoading:false,
      ShipmentDetails:{},
      customer:{},
      shipmentLogs:[],
      pictures:[],
      temp: '',
      isImages: false,
      numberOfImg:'',
      ProductArrObj: {},
      productsArr: [],
      IsMPS: false,
      IsSku: false,
      userDataKey : '',
      isRVPdropoff : '',
      imageViewerVisible: false,
      viewerClientImages: [],
      viewerSRImages: [],
      viewerSRPartialImages: [],
    }
  },
  created: function() {
  },
  watch: {
    shippingId: createClearInputWatcher('shippingId'),
  },
  mounted() {
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localhubdetails = userdetail.hubdetails[0];
    this.hubname = this.localhubdetails;
    this.userRoles = userdetail.userrole[0];
    this.username = userdetail.username;

    let TrackerInfo = {
      projectname:"Last Mile",
      type:"Web",
      userid:this.localuserid,
      username:this.localusermailid,
      meta: {
        "event":""
      }
    }
    let result  = this.PageTracker(TrackerInfo);
  },

  filters: {
    formatedDate: function(date) {
      if (date != null && date != '') {
        return moment(date).format('DD-MM-YY HH:MM:SS');
      }
    }
  },
  methods: {
    onSubmit: function(event) {

      this.isProductDetailsTableLoading = true;
      this.isImages = false;
      this.IsMPS = false;
      this.IsSku = false;
      this.showShipmentDetails ? this.showShipmentDetails = false : this.showShipmentDetails;
      this.showProductDetailsTable ? this.showProductDetailsTable = false : this.showProductDetailsTable;
      this.showShipmentLogTable ? this.showShipmentLogTable = false : this.showShipmentLogTable;
      this.$validator.validateAll().then( async (result) => {

        if(result){
          this.isTableLoading = true;
          const productInfo = await this.getProductDetails();
          productInfo ? this.showProductDetailsTable = true : this.showProductDetailsTable = false;
          const shipmentInfo = await this.getShipmentLog();
          shipmentInfo ? this.showShipmentLogTable = true : this.showShipmentLogTable = false;
          this.showShipmentDetails = true;
          this.isTableLoading = false;
        }
      }).catch((e) => {
        this.isProductDetailsTableLoading = false;
        console.log("Error Details", e);
        return false;
      });
    },

    getProductDetails(){
      return new Promise((resolve,reject) => {
        let reqPayload = {
          shippingID: this.shippingId.trim(),
          "requestedBy":this.username
        }
        this.ShipmentDetails = {}
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'shipment/getRVPproductdetails',
          data: reqPayload
        })
        .then(result => {
          applySmartInputStyles(this.$refs.shipmentNo, result.data.lossCategorization);
          this.isProductDetailsTableLoading = false;
          if( result.data.code === 200 ) {
            this.ShipmentDetails = result.data.data;

            if(this.ShipmentDetails.MultiShipmentGroupID){
              this.IsMPS = true;
            }
            if(this.ShipmentDetails.IsMultiSKU == true){
              this.IsSku = true;
            }
            this.productsArr = this.ShipmentDetails.ProductDetails;
            let customerDetails = this.ShipmentDetails.CustomerAddressDetails;

            this.customer = {
              name : customerDetails.Name,
              address : customerDetails.Address,
              city : customerDetails.City,
              state : customerDetails.State,
              pincode : customerDetails.PinCode,
              mobile : this.ShipmentDetails.CustomerContactDetails.PhoneNo
            }

            for(let products in this.productsArr){
              if (this.productsArr[products].PickupProductImage || this.productsArr[products].SRPickDoneImages || this.productsArr[products].TLQCImages || this.productsArr[products].WHImages || this.productsArr[products].SrPartialReversePickupImages || this.productsArr[products].TLQCSealImages) {
                this.isImages = true;
                this.showShipmentDetails = true;
                this.isRVPdropoff = this.ShipmentDetails.IsRVPDropOff ;
             
              }
            }
            this.showShipmentDetails = true;
            resolve(true)
          }
          else {
            this.$alertify.error(result.data.message);
            this.isTableLoading = false;
            reject(false)
          }
        }, error => {
          this.isProductDetailsTableLoading = false;
          console.log("Error Details", error);
          reject(false);
        })
      })
    },

    getShipmentLog() {
      return new Promise((resolve,reject) => {
        this.shipmentLogs = '';
        this.isShipmentLogTableLoading = true;
        axios.get(apiUrl.api_url + `external/getshipmentlog?ShippingID=${this.shippingId}`)
        .then( result => {

          this.isShipmentLogTableLoading = false;
          if (result.data.code === 200) {
            this.shipmentLogs = result.data.data;
            if (this.shipmentLogs.length > 0) {
              resolve(true);
            }else {
              reject(false);
            }
          }else {
            this.$alertify.error('Shipment Logs Not Found!');
            reject(false)
          }
        }).catch( error => {
          this.isShipmentLogTableLoading = false;
          console.log("Error Details", error);
          reject(false)
        })
      })
    },

    openImageViewer(data) {
      this.viewerClientImages = data.PickupProductImage || [];
      this.viewerSRImages = (data.SRPickDoneImages || []).filter(img => img && img.ImageUrl);
      this.viewerSRPartialImages = data.SrPartialReversePickupImages || [];
      this.imageViewerVisible = true;
      document.body.style.overflow = 'hidden';
    },

    closeImageViewer() {
      this.imageViewerVisible = false;
      document.body.style.overflow = '';
    },

    resetForm() {
      this.isProductDetailsTableLoading = false;
      this.isShipmentLogTableLoading = false
      this.showShipmentLogTable = false;
      this.showProductDetailsTable = false;
      this.showShipmentDetails = false;
      this.isTableLoading = false;
      this.isImages = false;
      this.IsMPS = false;
      this.IsSku = false;
      this.shippingId = '';
      this.ShipmentDetails = {};
      this.shipmentLogs = [];
      this.customer = {};
      this.productsArr = [];
      this.errors.clear();
      this.$validator.reset();
      clearSmartInputStyles(this.$refs.shipmentNo);
      this.imageViewerVisible = false;
      this.viewerClientImages = [];
      this.viewerSRImages = [];
      this.viewerSRPartialImages = [];
      document.body.style.overflow = '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ReversePickupShipmentDetails/ReversePickupShipmentDetails.component.js